export const planningQuestions: string[] = [
  'What should I teach next?',
  'How should I explain it?',
  'What should the student practice first?',
  'How should I correct this mistake?',
  'When is the student ready to progress?',
]

export const notBecause: string[] = [
  "Not because you don't know aviation.",
  "Not because you don't know how to fly.",
  "And not because you don't know how to teach.",
]

export const scratchHabits: string[] = [
  'You search for training ideas.',
  'You recreate explanations.',
  'You prepare another briefing.',
  'You look for visual references.',
  'You repeat whatever worked last time.',
  'You improvise progressions.',
  'You try to remember what the student should work on next.',
]

export const painPoints: string[] = [
  'Hours spent preparing lessons.',
  'Scattered training materials.',
  'Explaining complex flight concepts only verbally.',
  'Repeating the same briefings again and again.',
  'Students progressing without a clear sequence.',
  'No consistent correction system.',
  'No structured progress tracking.',
  'No quick visual reference during briefings.',
  'More time planning. Less time teaching.',
  'Walking into a lesson with an idea instead of a complete structure.',
]
